import { styled } from 'parkdepot-shared/theme'

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingXLarge,
    lineHeight: '38px',
    marginBottom: $theme.sizing.scale550
}))

export const ButtonCaption = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    color: $theme.colors.primaryA,
    textAlign: 'center',
    marginTop: $theme.sizing.scale400,
    marginBottom: $theme.sizing.scale800
}))

export const Link = styled('a', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    textDecorationLine: 'underline',
    cursor: 'pointer',
    textAlign: 'center'
}))

export const EmailInputContainer = styled('div', ({ $theme }) => ({
    marginTop: $theme.sizing.scale800,
    marginBottom: $theme.sizing.scale800
}))
